import { Heading, Link, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";

const PrivacyAndPolicy: React.FC = () => {
  return (
    <Stack
      // direction={["column", "row"]}
      w={"full"}
      h="100%"
      justifySelf={"flex-end"}
      bgGradient="linear(to-r, transparent, secondary.950 40%)"
      p={10}
      gap={5}
      overflow={"auto"}
      className="mac-scrollbar"
    >
      <Heading>Privacy Policy for Al-Quran</Heading>
      <Text>
        At Al-Quran, we prioritize the privacy and security of our users. This
        Privacy Policy outlines how we collect, use, and protect your personal
        information when you use our website and services.
      </Text>

      <HeadingLable
        heading={"1. Information Collection"}
        lable={
          "We may collect personal information that you provide voluntarily, such as your name, email address, and any other information required to use our services. Additionally, we may automatically collect information about your usage of the website, such as IP addresses and browser types, through cookies or similar technologies."
        }
      />
      <HeadingLable
        heading={"2. Use of Information"}
        lable={
          "We use the collected information to provide, maintain, and improve our services. This may include sending updates, newsletters, or other information related to our services. We will not share your personal information with third parties except as required by law or with your explicit consent."
        }
      />
      <HeadingLable
        heading={"3. Cookies"}
        lable={
          "Our website may use cookies to enhance your user experience. Cookies are small files placed on your device that allow us to remember your preferences. You can disable cookies in your browser settings, but this may affect the functionality of the website."
        }
      />
      <HeadingLable
        heading={"4. Data Security"}
        lable={
          "We implement reasonable security measures to protect your personal information from unauthorized access, alteration, or destruction. However, no method of data transmission over the internet is 100% secure, and we cannot guarantee the absolute security of your information."
        }
      />
      <HeadingLable
        heading={"5. Third-Party Links"}
        lable={
          "Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites."
        }
      />
      <HeadingLable
        heading={"6. Changes to this Privacy Policy"}
        lable={
          "We reserve the right to update this Privacy Policy from time to time. Any changes will be posted on this page, and the updated date will be noted at the top of the policy."
        }
      />

      <VStack align={"self-start"}>
        <Heading size={"lg"}>7. Contact Us</Heading>
        <Text>
          "If you have any questions about this Privacy Policy, please contact
          us at{" "}
          <Link
            onClick={() =>
              (window.location.href = "mailto:info@alquran.network")
            }
            color="teal.500"
          >
            info@alquran.network.
          </Link>
        </Text>
      </VStack>
    </Stack>
  );
};

export default PrivacyAndPolicy;

const HeadingLable: React.FC<{
  lable: string;
  heading: string;
}> = ({ lable, heading }) => {
  return (
    <VStack align={"self-start"}>
      <Heading size={"lg"}>{heading}</Heading>
      <Text>{lable}</Text>
    </VStack>
  );
};
